<template>
    <div class="schools-base">
        <staticWelcomeSearch :title="'Local Schools'" :searchType="'Schools'"/>
        <mvtPageMenu :menuType="'Schools'" />
        <schoolsBreadcrumb :breadCrumb="getBreadCrumbData"/>
        <section v-if="data.dataList && data.dataList.length" v-for="(list, index) in data.dataList">
          <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
            <mvtCollapsibleLinks
                :title="list.title"
                titleClass="f3 text-capitalize text-bold p-y-2"
                :links='formatDataList(list.data)'
                :key="index"
                :initialExpandedState="true"
            />
          </div>
        </section>
    </div>
</template>

<script src="./schools-base.js"></script>

<style lang="scss">
@use './schools-base.scss' as *;
</style>
